import React, { useState, useEffect } from 'react';
import { Modal, Button, Upload, Typography, Form, Row, message, Col, Input } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { COMPANY_INFO_WARNING_MESSAGE, extractApiErrorMessage, openNotification } from '../../utils';
import ProposalService from '../../services/ProposalService';
import DocumentService from '../../services/DocumentService';

const { Text } = Typography;

const ApproveDocument: React.FC<any> = ({ proposalId, isModalVisible, setIsModalVisible, setIsStatusChange = false, type = 1 }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);
    const [documentName, setDocumentName] = useState<string | null>(null);
    const [preSignUrl, setPreSignUrl] = useState<string | null>(null);
    const [isImage, setIsImage] = useState<boolean>(false);
    const [roles, setRoles] = useState<any>();
    // Reddetme için ikinci modal ve not
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
    const [rejectNote, setRejectNote] = useState<string>('');

    useEffect(() => {
        if (isModalVisible && proposalId) {
            fetchProposalDocument();
        }
    }, [isModalVisible, proposalId]);

    useEffect(() => {
        let storedRoles: any = localStorage.getItem('roles');
        let parsedRoles = JSON.parse(storedRoles);
        setRoles(parsedRoles);
    }, [])

    const fetchProposalDocument = async () => {
        try {
            const response = await ProposalService.get(proposalId);
            const documentId = response?.data?.documentId;

            if (documentId) {
                const responseDocument: any = await DocumentService.getDocument(documentId);
                const documentData = responseDocument?.data;

                if (documentData) {
                    setDocumentName(documentData.code);
                    setPreSignUrl(documentData.preSignUrl);

                    // Dosya uzantısına göre bir resim olup olmadığını kontrol et
                    const fileType = documentData.code.split('.').pop().toLowerCase();
                    setIsImage(['jpg', 'jpeg', 'png'].includes(fileType));
                } else {
                    setDocumentName(null);
                    setPreSignUrl(null);
                    setIsImage(false);
                }
            }
        } catch (error) {
            openNotification('error', 'Hata', 'Belge bilgisi getirilemedi.');
            console.error(error);
        }
    };

    const handleFileChange = ({ fileList }: any) => {
        setFileList(fileList.slice(-1)); // Tek bir dosyaya izin veriliyor
    };

    const handleUpload = async () => {
        if (fileList.length === 0) {
            message.warning("Lütfen bir dosya seçin.");
            return;
        }

        setIsLoading(true);

        try {
            const fileName = fileList[0].name;
            const uploadResponse: any = await DocumentService.postDocument(fileList[0].originFileObj, fileName);
            const documentId: any = uploadResponse?.data?.id;

            if (documentId) {
                await ProposalService.updateDocumentId(proposalId, { documentId });
                openNotification('success', 'Başarılı', 'Sözleşme Yüklendi');
                setIsStatusChange(true);
                setFileList([]);
                setIsModalVisible(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
            setIsModalVisible(false);
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setFileList([]);
        setDocumentName(null);
        setPreSignUrl(null);
        setIsImage(false);
    };

    const handleChange = async (proposalId: any, statusId: number) => {
        try {
            // Onay doğrudan gönderilir; reddet yeni modal ile not sonrası gönderilir
            await ProposalService.updateStatus(proposalId, statusId);
            if (statusId === 6) {
                openNotification('success', 'Başarılı', 'Sözleşme Başarıyla Onaylandı');
            }
            setIsModalVisible(false);
            console.log(`Teklif ${proposalId} başarıyla güncellendi.`);
        } catch (error) {
            const message = extractApiErrorMessage(error, 'Teklif güncellenirken hata oluştu.');
            const isCompanyWarning = message === COMPANY_INFO_WARNING_MESSAGE;
            openNotification(isCompanyWarning ? 'warning' : 'error', isCompanyWarning ? 'Uyarı' : 'Hata', message);
            console.error(`Teklif güncellenirken hata oluştu:`, error);
        }
    };

    const handleRejectConfirm = async () => {
        const note = rejectNote.trim();
        if (!note) {
            message.warning('Lütfen reddetme için bilgilendirme notu girin.');
            return;
        }
        try {
            await ProposalService.updateStatus(proposalId, 14, { contractRejectionNote: note });
            openNotification('success', 'Başarılı', 'Sözleşme Reddedildi');
            setIsRejectModalVisible(false);
            setRejectNote('');
            setIsModalVisible(false);
        } catch (error) {
            console.error('Reddetme işlemi başarısız:', error);
            message.error('Reddetme işlemi sırasında hata oluştu');
        }
    };

    return (
        <>
            <Modal
                title={type == 1 ? <Text className="modal-title">Sözleşme Yükle</Text> : <Text className="modal-title">Sözleşmeyi Kontrol Et</Text>}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                className="planlama-modal"
            >
                <Form layout="vertical">
                    {type === 1 &&
                        <Text>Yüklediğiniz sözleşme, KONTROLX tarafından incelenecek ve uygun ise onaylanacaktır. Lütfen yüklediğiniz sözleşmenin doğru ve eksiksiz olduğundan emin olun.</Text>
                    }
                    <br />
                    {documentName && (
                        <div style={{ marginTop: 16 }}>
                            {/* <a href={preSignUrl ?? ''}>
                            <Text style={{ backgroundColor: '#F5F5F5', color: '#1890FF' }} strong>{documentName}</Text>
                        </a> */}
                            {isImage && preSignUrl ? (
                                <div style={{ marginTop: 16, textAlign: 'center' }}>
                                    <a href={preSignUrl}>
                                        <img src={preSignUrl} alt="Document Preview" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                                    </a>
                                </div>
                            ) : null}
                            <Row justify="center" style={{ marginTop: 16 }}>
                                {preSignUrl && (
                                    <Button type="link" href={preSignUrl} target="_blank" download>
                                        Dosyayı İndir
                                    </Button>
                                )}
                            </Row>
                            <Row justify="end" gutter={[16, 16]} style={{ marginTop: 16 }}>
                                <Col>
                                    <Button type="default" onClick={() => { setIsRejectModalVisible(true); setRejectNote(''); }}>
                                        Reddet
                                    </Button>
                                </Col>
                                <Col>
                                    <Button type="primary" onClick={() => handleChange(proposalId, 6)}>
                                        Onayla
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    )}


                </Form>
            </Modal>
            {/* Reddetme Sebebi Modal */}
            <Modal
                title="Reddetme Sebebi"
                open={isRejectModalVisible}
                onCancel={() => { setIsRejectModalVisible(false); setRejectNote(''); }}
                onOk={handleRejectConfirm}
                okText="Gönder"
                cancelText="Vazgeç"
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Not"
                        name="rejectNote"
                        rules={[
                            {
                                required: true,
                                message: "Sözleşmenin kabul edilmeme sebebi detaylı şekilde girilmelidir.",
                            },
                        ]}
                    >
                        <Input.TextArea
                            rows={3}
                            value={rejectNote}
                            onChange={(e) => setRejectNote(e.target.value)}
                            placeholder="Örn. Sözleşmenin imzasız olarak yüklenmiş olması"
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ApproveDocument;
